import { Routes } from '@angular/router';
import * as c from './components';
import { AuthGuard,RoleGuard } from './guards';
import { UserResolver } from './resolvers';

export const routes: Routes = [
  { path: 'dashboard', redirectTo: 'correspondences' },
  {
    path: 'download/:id',
    component: c.DownloadComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'correspondences/:filter',
    component: c.FilteredDashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'correspondences',
    component: c.DashboardComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'correspondence/add',
    component: c.AddCorrespondenceComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'correspondence/:id',
    component: c.CorrespondenceComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'correspondence/:id/documents/add',
    component: c.AddDocumentComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  { path: 'correspondence/:id/documents', redirectTo: 'correspondence/:id' },
  {
    path: 'correspondence/:id/reviews/add',
    component: c.AddReviewComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  { path: 'correspondence', redirectTo: 'correspondences' },
  {
    path: 'correspondence/:cid/reviews/:rid',
    component: c.ReviewComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'correspondence/:cid/reviews/:rid/documents/add',
    component: c.AddDocumentComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'correspondence/:cid/reviews/:rid/documents',
    redirectTo: 'correspondence/:cid/reviews/:rid',
  },
  { path: 'correspondence/:cid/reviews', redirectTo: 'correspondence/:cid' },
  {
    path: 'contacts',
    component: c.ManageContactsComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'contacts/:id',
    component: c.ContactComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'contacts/:id/detail/:id',
    component: c.ContactDetailsComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  { path: 'contacts/:id/detail', redirectTo: 'contacts/:id' },
  {
    path: 'users',
    component: c.UserManagerComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'users/add',
    component: c.AddUserComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'users/:id',
    component: c.UserDetailsComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'choose/user',
    component: c.UserChooserComponent,
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'settings',
    component: c.ManageSettingsComponent,
    resolve: { user: UserResolver },
    canActivate: [AuthGuard, RoleGuard],
  },
  { path: 'login', component: c.LoginComponent },
  { path: 'help', component: c.HelpComponent },
  { path: '**', redirectTo: 'help' },
];
